module.exports = __webpack_public_path__ + "static/UnclickSpecial-b06f0303af5e04d6387def311dac1999.png";